import DataService from "@/services/DataService.js";

export default {
  login(data) {
    return DataService.apiClient.post("/user/login", data);
  },
  refreshToken(refresh_token) {
    return DataService.apiClient.post("/user/token", {
      refreshToken: refresh_token,
    });
  },
  logout() {
    return DataService.apiClient.delete("/user/logout");
  },
  setAuthToken(token) {
    DataService.apiClient.defaults.headers.common[
      "Authorization"
    ] = ` Bearer ${token}`;
  },
  fetchAll() {
    return DataService.apiClient.get("/user");
  },
  fetch(id) {
    return DataService.apiClient.get("/user/" + id);
  },
  createIdCards() {
    return DataService.apiClient.post(
      "/user/idcards",
      {},
      { responseType: "arraybuffer" }
    );
  },
  createIdCard(userid) {
    return DataService.apiClient.post(
      `/user/idcards/${userid}`,
      {},
      { responseType: "arraybuffer" }
    );
  },
  resendActivation(id) {
    return DataService.apiClient.post("/user/resendActivation", { _id: id });
  },
  fetchByActivationToken(token) {
    return DataService.apiClient.get("/user/activate/" + token);
  },
  activateUser(data) {
    return DataService.apiClient.patch("/user/activate/", data);
  },
  pwResetCheckEmail(email) {
    return DataService.apiClient.post("/user/pwreset/", { email });
  },
  pwResetCheckCode(code, email) {
    return DataService.apiClient.post("/user/pwreset/code", { code, email });
  },
  pwReset(data) {
    return DataService.apiClient.patch("/user/pwreset/", data);
  },
  saveUser(user) {
    if (user.id != null) {
      return DataService.apiClient.patch("/user/edit/" + user.id, user.data);
    } else {
      return DataService.apiClient.post("/user/add", user.data);
    }
  },
  delete(id) {
    return DataService.apiClient.delete("/user/delete/" + id);
  },
  deleteUsersOfCustomer(customerId) {
    return DataService.apiClient.post("/user/deleteByCustomer", { customerId });
  },
};
